<template>
    <div class="d-flex flex-column align-center" style="position: relative;" >
        <!--<h2 style="color: dimgrey">Desbloquear Utilizador</h2>-->
        <!-- Loading local -->
        <v-alert v-if="showSuccess"
      dense
      text
      type="success"
    >
      <span v-html="$t('auth.unblock.success')"></span>
    </v-alert>
    <v-alert v-if="showFailed"
      dense
       type="info"
    >
      {{ $t('auth.unblock.expired') }}
    </v-alert>
        <v-overlay :value="loading" absolute>
            <div class="text-center">
                <v-progress-circular
                indeterminate
                color="primary"
                size="60"
                ></v-progress-circular>
                <div class="mt-2">{{ $t('auth.unblock.verifying') }}</div>
            </div>
            </v-overlay>
       <!-- <p class="subtitle-2 mb-16" style="color: darkgrey">
            Por favor verifique o seu email para poder aceder ao portal.
        </p>-->

        <!--<social-media-auth>
        </social-media-auth>-->
    </div>
</template>

<script>
import AuthLayout from "../Layouts/AuthLayout";
import { axios } from '@/Services/Backend';

export default {
    layout: AuthLayout,
    data() {
        return {
            showSuccess:false,
            showFailed:false,
            loading: false, // ou false, depende da lógica
            token:null
        };
  },
  mounted() {

    const query = new URLSearchParams(window.location.search);
    this.token = query.get('t');
    //console.log('size',this.token, this.$inertia);
    if(_.size(this.token)>15){
        this.loading = true;
        setTimeout(() => {
            this.checkCode()
        }, 4000);
    }else{
        this.$inertia.visit('/');
    }

  },
  methods:{
    checkCode() {
            //if (!this.$refs.form.validate()) return;

            //this.form.errors = null;
            axios
                .post('/verify/unlock-account', {code:this.token})
                .then(() => {
                    this.loading = false;
                    this.showSuccess=true
                    setTimeout(() => {
                        this.$inertia.visit('/');
                    }, 3000);
                    //this.userStore.login(this.$inertia, this.$tawkMessenger);
                })
                .catch((error) => {
                    //const errors = error.response.data.errors;
                    //this.showSuccess=false
                    this.showFailed=true
                    this.loading = false;
                    setTimeout(() => {
                        this.$inertia.visit('/');
                    }, 5000);
                    //console.log('error',errors,error)
                    //this.form.errors = errors;
                });
        },
  }

};
</script>

<style>
html {
    overflow-y: auto !important;
}
.v-overlay,.v-alert{
    margin-top: 20vh;
}
.mt-2{
    width: 30vw;
    color: #006DB6;
    font-size: 20px;
}
</style>
